import { DictItem, DictEnum, DictInfo, DictInfoVal } from "@/types/dict";
import request from ".";

const url = "/wms/dict";

const apis = {
  add: (type: DictEnum) => url + `/type/${type}/add`,
  addIgnoreEnum: (type: string) => url + `/type/${type}/add`,
  dictListIgnoreEnum: (type?: string) => url + `${type ? "/type/" + type : ""}/list`,
  del: (id: string) => url + `/${id}/del`,
  list: (type?: DictEnum) => url + `${type ? "/type/" + type : ""}/list`,
  newList: (type?: string) => url + `${type ? "/type/" + type : ""}/list`,
  update: (id: string) => url + `/${id}/update`,
  set: (type?: string) => url + `/type/${type}/set`
};

export const list = () => {
  return new Promise<Array<DictItem>>((resolve, reject) => {
    request<Array<DictItem>, void>(apis.list())
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const newList = (type: string, supplierApi?: string) => {
  return new Promise<Array<DictItem>>((resolve, reject) => {
    request<Array<DictItem>, void>(apis.newList(type), { requestConfig: supplierApi ? { baseURL: supplierApi } : undefined })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const add = (type: DictEnum, props: DictInfo) => {
  return new Promise<DictItem>((resolve, reject) => {
    request<DictItem, DictInfo & { value: "" }>(apis.add(type), {
      params: { body: { ...props, value: "" } },
    })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

//忽略类型【仅用于构造品牌相关树形数据】
export const addIgnoreEnum = (type: string, props: DictInfo) => {
  return new Promise<DictItem>((resolve, reject) => {
    request<DictItem, DictInfo & { value: "" }>(apis.addIgnoreEnum(type), {
      params: { body: { ...props, value: "" } },
    })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const dictListIgnoreEnum = (type: string, supplierApi?: string) => {
  return new Promise<Array<DictItem>>((resolve, reject) => {
    request<Array<DictItem>, void>(apis.dictListIgnoreEnum(type), { requestConfig: supplierApi ? { baseURL: supplierApi } : undefined })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};
export const update = (id: string, params: DictInfo) => {
  return new Promise<void>((resolve, reject) => {
    request<void, DictInfo>(apis.update(id), {
      params: { body: params },
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const addVal = (type: DictEnum, props: DictInfoVal) => {
  return new Promise<DictItem>((resolve, reject) => {
    request<DictItem, DictInfo & { desc: "" }>(apis.add(type), {
      params: { body: { ...props, desc: "" } },
    })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  });
};

export const updateVal = (id: string, params: DictInfoVal) => {
  return new Promise<void>((resolve, reject) => {
    request<void, DictInfoVal>(apis.update(id), {
      params: { body: params },
    })
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const del = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, void>(apis.del(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const set = (id: string, params: any) => {
  return new Promise<Array<DictItem>>((resolve, reject) => {
    request<Array<DictItem>, DictInfo>(apis.set(id), {
      params: { body: params },
    })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};

export const updateDic = (id: string, params: DictInfo) => {
  return new Promise<DictItem>((resolve, reject) => {
    request<DictItem, DictInfo>(apis.update(id), {
      params: { body: params },
    })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  });
};

const exportObject = {
  list,
  add,
  addIgnoreEnum,
  dictListIgnoreEnum,
  del,
  fetch,
  update,
};

export default exportObject;